<!--医美/抗衰资产明细-->
<template>
    <div class="customerList-module">
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索名称/编号"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex-y-center flex-start">
            <div class="add-customer flex-1 ">
                <span>总资产：</span>
                <span class="add-customer-number">{{totalAmountList.totalProductBalanceAmount}}</span>
                <span>万</span>
                <span class="sheets">总数量：</span>
                <span class="add-customer-number">{{totalAmountList.totalProductCount}}</span>
            </div>
            <div class="select-item flex-between flex-y-center" @click="selectSortPopup">
                <div class="select-tit">{{ checkedSort && checkedSort.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>

        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getList"
                    :offset="20" :immediate-check="false">
                    <div class="customer-list" v-for="(item, index) in medicalList" :key="index"
                        @click="toDetail(item.productSku,item.productName)">
                        <div class="flex-y-center">
                            <div class="customer-info flex-1">
                                {{item.productName}}
                            </div>
                            <img class="arrow_right" referrerpolicy="no-referrer"
                                src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" alt="" />
                        </div>
                        <div class="customer-remark flex-between flex-y-center">
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">资产：</span>
                                <span class="sale-number">{{item.productPropertyAmount}}万</span>
                            </div>
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">次数：</span>
                                <span class="sale-number">{{item.productCount}}</span>
                            </div>
                            <div class="flex-between flex-y-center">
                                <span class="sale-name">持有顾客数：</span>
                                <span class="sale-number">{{item.customerCount}}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
            <van-popup v-model="showSortPopup" round position="bottom" closeable class="popup">
                <picker title="排序" v-model="checkedSort" :list="sortList" @change="onSortChange"></picker>
            </van-popup>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import Picker from '@/components/Picker';
import { Search, Toast } from "vant";

export default {
    name: "medicalAestheticsAssets",
    components: {
        [Search.name]: Search, Picker
    },
    data() {
        return {
            searchStr: '',  // 搜索条件
            page: 1,       // 当前页
            limit: 10,       // 每页多少条
            total: 0,     // 列表总条数
            totalAmountList: [],   //资产总数列表
            medicalList: [],    // 列表
            loading: false,    // 加载
            finished: false,    // 结束加载
            refreshing: false,   // 刷新
            sortList: [], // 排序
            checkedSort: null,//所选排序
            showSortPopup: false,   //筛选弹出框   
        };
    },
    beforeRouteEnter(to, from, next) {
        if (from.path == '/medicalAestheticsDetail') {
            to.meta.keepAlive = true;
            to.meta.isBack = true;
        } else {
            to.meta.keepAlive = false;
        }
        next()
    },
    activated() {
        if (!this.$route.meta.isBack) {
            this.onLoad()
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        onLoad() {
            // 初始化data的值
            Object.assign(this.$data, this.$options.data())
            this.init();
        },
        async init() {
            await this.getSortList()
            this.getList()
        },
        getList() {
            this.loading = true
            let params = {
                searchStr: this.searchStr,
                propertySortType: this.searchStr,
                limit: this.limit,
                page: this.page,
                id: this.$route.query.id,
                storeId: this.$route.query.storeId
            }
            request({
                url: "/debt/medicalProperty?searchStr=" + this.searchStr +
                    "&propertySortType=" + this.checkedSort.id +
                    '&limit=' + this.limit +
                    '&page=' + this.page,
                method: "get",
                params: params
            })
                .then((res) => {
                    this.totalAmountList = res.data;
                    this.medicalList = this.page == 1 ? res.data.medicalPropertyPage.list : this.medicalList.concat(res.data.medicalPropertyPage.list);
                    this.page += 1;
                    this.total = res.data.medicalPropertyPage.total;

                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    this.refreshing = false;
                    if (this.medicalList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },

        // 获取排序
        getSortList() {
            return request({
                url: "/debt/servicePropertySortList",
                method: "get",
            })
                .then((res) => {
                    this.sortList = res.data
                    this.checkedSort = this.sortList[0] //默认全部

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },

        //搜索
        onSearch() {
            this.page = 1
            this.getList();
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.medicalList = [];
            this.refreshing = false;
            this.getList();
        },
        //查看详情
        toDetail(productSku, productName) {
            this.$router.push({
                name: "medicalAestheticsDetail", query: {
                    productSku: productSku, productName: productName, id: this.$route.query.id,
                    storeId: this.$route.query.storeId
                }
            });
        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.onRefresh()
        },
        // 弹窗
        selectSortPopup() {
            this.showSortPopup = true
        },
        onSortChange(data) {
            this.showSortPopup = false
            this.checkedSort = data
            this.onRefresh()
        },
    },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    display: none;
}
.mr-30 {
    margin-right: 30px;
}
.add-customer {
    font-size: 26px;
    color: #66757f;
    line-height: 37px;
}
.customer-info {
    height: 42px;
    font-size: 30px;
    font-weight: 700;
    color: #35434c;
    line-height: 42px;
    margin-top: 10px;
}
.sheets {
    margin-left: 30px;
}
.add-customer-number {
    color: #f65252;
    font-weight: 700;
    font-size: 30px;
}

.list-box {
    width: 100%;
    height: calc(100vh - 245px);
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
    padding: 0 30px 30px 30px;
}

.customer-list {
    width: 690px;
    height: 172px;
    background: #fafafe;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 20px;
}

.customer-name {
    min-width: 60px;
    height: 42px;
    font-size: 30px;
    color: #35434c;
    line-height: 42px;
    font-weight: 700;
}
.churn-time {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin-top: 11px;
}
.nursing-edit-box {
    margin: 37px 0 0 163px;
}
.arrow_right {
    width: 15px;
    height: 26px;
}

.card-image {
    height: 34px;
    width: 90px;
    margin: 24px 0 0 10px;
}
.customerHeadPortrait {
    width: 90px;
    height: 90px;
    border-radius: 45px;
}
.customer-remark {
    padding: 30px 0 30px 0;
}
.sale-name {
    height: 40px;
    font-size: 28px;
    color: #a0acb5;
    line-height: 40px;
}
.sale-number {
    height: 40px;
    font-size: 28px;
    font-weight: 700;
    color: #35434c;
    line-height: 40px;
}
.select-box {
    padding: 0 30px 40px 31px;
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}
.van-pull-refresh {
    min-height: 100%;
}

:deep(.search-button.van-search) {
    padding: 30px 30px 30px 30px;
}
:deep(.search-button .van-icon) {
    font-size: 28px;
}
:deep(.search-button .van-search__content) {
    padding-left: 28px !important;
}
:deep(.search-button .van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 0 !important;
    margin-right: 0 !important;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}
</style>

